$(() => {
  $("[data-tabs]").on("change.zf.tabs", (event) => {
    const $container = $(event.target).parent().next(".tabs-content").find(".tabs-panel.is-active");
    let $content = $container.find(".editor .ProseMirror");
    if ($content.length > 0) {
      $content.focus();
    } else {
      $content = $container.find("input:first");
      if ($content.length > 0) {
        $content.focus();
      }
    }
  });
});
